import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { sendResetPasswordLink } from '../services/operations/authAPI';
import { BiArrowBack } from 'react-icons/bi';

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const { authLoading } = useSelector((state) => state.auth);
    const [email, setEmail] = useState('');
    const [emailSent, setEmailSent] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(sendResetPasswordLink(email, setEmailSent));
    };

    return (
        <div className="min-h-[calc(100vh-3.5rem)] flex items-center justify-center bg-richblack-900 px-4">
            <div className="w-full max-w-md">
                {/* Card Container */}
                <div className="bg-richblack-800 rounded-xl p-8 shadow-lg border border-richblack-700">
                    {/* Header */}
                    <h1 className="text-3xl font-semibold text-richblack-5 mb-2">
                        {!emailSent ? "Reset Your Password" : "Check Your Email"}
                    </h1>
                    <p className="text-richblack-300 mb-8">
                        {!emailSent
                            ? "Enter your email address and we'll send you a link to reset your password."
                            : `We've sent a password reset link to ${email}. Please check your inbox.`
                        }
                    </p>

                    {!emailSent ? (
                        <form onSubmit={handleSubmit}>
                            <label className="block">
                                <p className="text-richblack-100 mb-2">
                                    Email Address <sup className="text-pink-200">*</sup>
                                </p>
                                <input
                                    type="email"
                                    name="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email address"
                                    required
                                    className="w-full rounded-lg bg-richblack-700 text-richblack-5 p-3 border border-richblack-600 focus:border-yellow-50 focus:outline-none transition-colors"
                                    style={{ boxShadow: "rgba(255, 255, 255, 0.18) 0px -1px 0px inset" }}
                                />
                            </label>

                            <button
                                type="submit"
                                disabled={authLoading}
                                className="w-full mt-6 py-3 px-4 rounded-lg bg-yellow-50 text-richblack-900 font-semibold hover:bg-yellow-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {authLoading ? "Sending..." : "Send Reset Link"}
                            </button>
                        </form>
                    ) : (
                        <div className="space-y-4">
                            {/* Success Icon */}
                            <div className="flex justify-center mb-6">
                                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#4F46E5] to-[#7C3AED] flex items-center justify-center">
                                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                            </div>

                            {/* Resend Button */}
                            <button
                                onClick={handleSubmit}
                                disabled={authLoading}
                                className="w-full py-3 px-4 rounded-lg bg-yellow-50 text-richblack-900 font-semibold hover:bg-yellow-100 transition-colors disabled:opacity-50"
                            >
                                {authLoading ? "Sending..." : "Resend Email"}
                            </button>
                        </div>
                    )}

                    {/* Back to Login */}
                    <Link to="/login" className="flex items-center gap-2 text-richblack-300 hover:text-richblack-100 mt-6 transition-colors">
                        <BiArrowBack />
                        <span>Back to Login</span>
                    </Link>
                </div>

                {/* Additional Help */}
                <p className="text-center text-richblack-400 text-sm mt-6">
                    Remember your password?{' '}
                    <Link to="/login" className="text-yellow-50 hover:underline">
                        Sign in
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default ForgotPassword;
